import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/icon';
import { NotificationBell } from '@/components/notification-bell';
import { UserMenu } from '@/components/user-menu';

export interface TopbarProps {
  onOpenCommandPalette: () => void;
  /** SP4: open the mobile nav drawer (hamburger, small screens only). */
  onOpenMobileNav?: () => void;
}

export function Topbar({ onOpenCommandPalette, onOpenMobileNav }: TopbarProps): JSX.Element {
  const { t } = useTranslation(['common']);
  return (
    <header data-testid="topbar" className="flex h-14 items-center gap-4 border-b border-border bg-background px-4">
      <button
        type="button"
        data-testid="topbar-mobile-nav"
        onClick={onOpenMobileNav}
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-muted-foreground hover:bg-muted md:hidden"
        aria-label={t('open_navigation', { defaultValue: 'Ouvrir la navigation' })}
      >
        <Icon name="menu" size={18} />
      </button>
      <button
        type="button"
        data-testid="topbar-cmdk-pill"
        onClick={onOpenCommandPalette}
        className="flex h-9 flex-1 items-center gap-2 rounded-full border border-input bg-muted/40 px-3 text-sm text-muted-foreground hover:bg-muted"
      >
        <Icon name="search" size={14} />
        <span>{t('command_palette.placeholder')}</span>
        <span className="ml-auto rounded border border-input bg-background px-1.5 py-0.5 text-xs">
          ⌘K
        </span>
      </button>
      <NotificationBell />
      <UserMenu />
    </header>
  );
}
